import type { Translation } from 'primeng/api';
import { en } from 'primelocale/js/en.js';
import { fr } from 'primelocale/js/fr.js';

import { primengFrCaOverrides } from './primeng-fr-ca-overrides';

/** PrimeNG locale strings for English (United States). */
export const primengTranslationEnUs = en as Translation;

/** PrimeNG locale strings for French (Canada). */
export const primengTranslationFrCa = { ...fr, ...primengFrCaOverrides } as Translation;

/**
 * Returns PrimeNG locale strings for the active Angular build locale.
 * Uses `$localize.locale` so dual-locale production builds get the correct bundle.
 */
export function getPrimengTranslation(): Translation {
  const locale = typeof $localize !== 'undefined' ? $localize.locale : 'en-US';

  if (locale === 'fr-CA') {
    return primengTranslationFrCa;
  }

  return primengTranslationEnUs;
}
